import {
  addNavMenuItem,
  registerCustomDetailComponent,
  registerBulkAction,
} from "@bb-vendure/admin-ui/core";
import { UserLevelSetterComponent } from "./components/UserLevelSetter/setter.component";
import UserPointRecordsComponent from "./components/UserPointRecords/records.component";
import { bulkLevelDelete } from "./bulkAction";

export default [
  addNavMenuItem(
    {
      id: "user-level",
      label: "nav.customer-level",
      routerLink: ["/extensions/user-level"],
      icon: "star",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadUserLevel");
      },
    },
    "rule-section"
  ),

  registerCustomDetailComponent({
    locationId: "customer-detail",
    component: UserLevelSetterComponent,
  }),

  registerCustomDetailComponent({
    locationId: "customer-detail",
    component: UserPointRecordsComponent,
  }),

  registerBulkAction(bulkLevelDelete),
];
